const MiniLoader = props =>{
    return(
        <div className="mini-loader"><span className="text-success text-center"><i className="fa fa-spinner fa-spin" aria-hidden="true"></i>&nbsp;{props.message}</span></div>
    )
}
export default MiniLoader;